import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { EditToggleService } from '../services/edit-toggle.service';
var EditToggleComponent = /** @class */ (function () {
    function EditToggleComponent(_toggleService) {
        this._toggleService = _toggleService;
        // toggleLabel = 'Edit Mode Off';
        this.checked = false;
    }
    EditToggleComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.checked = this._toggleService.getState();
                this._toggleService.toggleEmitter.subscribe(function (isOn) {
                    _this.checked = isOn;
                });
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(EditToggleComponent.prototype, "toggleText", {
        get: function () {
            return this.checked ? 'Edit Mode On' : 'Edit Mode Off';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * fn trigers when edit mode switch is clicked by user.
     */
    EditToggleComponent.prototype.onEditModeChanged = function (event) {
        this.checked = event.checked;
        this._toggleService.setState(event.checked);
        // this.toggleLabel = event.checked ? 'Edit Mode On' : 'Edit Mode Off';
    };
    return EditToggleComponent;
}());
export { EditToggleComponent };
